import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { leawoodConfig } from "./data";

export default function LeawoodPage() {
  return <CityPageTemplate config={leawoodConfig} />;
}